import React from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import { useDispatch, useSelector } from "react-redux";
import configureStore from "../../../store/configureStore";
import Bill from "./common/Bill";
import { history } from "../../../reducers";
import Loader from "../../common/Loader";
import { get_orgunit_details } from "../../../actions/action-orgunit";
import { get_sales_return_details } from "./actions/action-salesReturn";
import NewBill from "./common/NewBill";

const store = configureStore();

function SalesReturnDetails() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { salesReturnDetails, showGlobalLoader } = useSelector(
    (state) => state.salesReturn
  );
  const { OrgunitDetails } = useSelector((state) => state.orgunit);

  useEffect(() => {
    let salesReturnId = window.location.pathname.split("/");
    salesReturnId = salesReturnId[3];
    console.log("salesReturnId", salesReturnId);

    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_sales_return_details(salesReturnId, activeOuid));
      await dispatch(get_orgunit_details(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Sales Return Details" />
      <div className="AppPage container--narrow mt FBAppPage">
        <button
          className="bill_edit_btn mb"
          onClick={() =>
            history.push(
              `/${activeOuid}/edit-sales-return/${salesReturnDetails.id}`
            )
          }
        >
          Edit
        </button>
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <>
            <NewBill
              billDetails={salesReturnDetails}
              companyDetails={OrgunitDetails}
            />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default SalesReturnDetails;
